export default __webpack_public_path__ + "static/media/DevTracker.657047cf.png";